import React from 'react';
import SideBar from '../../Parts/SideBar';
import Footer from '../../Organisms/Footer';
import Header from '../../Organisms/Header';
import { useKeycloak } from '@react-keycloak/web';

const MainLayout = ({ children }) => {
    const { keycloak, initialized } = useKeycloak();
    const userRoles = keycloak.tokenParsed?.realm_access.roles;
    const isProcessUser = userRoles?.includes('mjv-user');

    return (
        <div className="wrapper-content">
            {userRoles && userRoles.length > 0 && !isProcessUser && initialized && (
                <SideBar />
            )}
            <div className="w-100 overflow-auto">
                {initialized && keycloak.token && <Header />}
                {children}
                <Footer />
            </div>
        </div>
    );
};

export default MainLayout;
